import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fullName',
  standalone: false
})
export class EmployeeFullNamePipe implements PipeTransform {
  transform(value: { firstName: string, lastName?: string | null }): string {
    return [value.firstName, value.lastName].join(' ').trim();
  }
}
